import {Subscription} from 'rxjs';

import IPlayer from '../../../Player/Interfaces/IPlayer';

import createEstimatedBandwidtheWriteStream from './Streams/createEstimatedBandwidthWriteStream';
import createVolumeLevelWriteStream         from './Streams/createVolumeLevelWriteStream';
import createVolumeMutedWriteStream         from './Streams/createVolumeMutedWriteStream';
import subscribeToEstimatedBandwidthWrite   from './Subscribers/subscribeToEstimatedBandwidthWrite';
import subscribeToVolumeLevelWrite          from './Subscribers/subscribeToVolumeLevelWrite';
import subscribeToVolumeMutedWrite          from './Subscribers/subscribeToVolumeMutedWrite';

const connectLocalStorageSubscriptions = (player: IPlayer): Subscription[] => {
    const {localStorage, playback, volume} = player.state.stores;

    return [
        subscribeToEstimatedBandwidthWrite(createEstimatedBandwidtheWriteStream(playback.update$), localStorage),
        subscribeToVolumeLevelWrite(createVolumeLevelWriteStream(volume.update$), localStorage),
        subscribeToVolumeMutedWrite(createVolumeMutedWriteStream(volume.update$), localStorage)
    ];
};

export default connectLocalStorageSubscriptions;